import React from 'react';

export const BookmarkWhiteFullIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.33331 4.16699C3.33331 3.50395 3.59671 2.86807 4.06555 2.39923C4.53439 1.93038 5.17027 1.66699 5.83331 1.66699H14.1666C14.8297 1.66699 15.4656 1.93038 15.9344 2.39923C16.4033 2.86807 16.6666 3.50395 16.6666 4.16699V17.5237C16.6666 18.5403 15.5166 19.132 14.69 18.5412L9.99998 15.1912L5.30998 18.5412C4.48248 19.1328 3.33331 18.5412 3.33331 17.5245V4.16699Z"
        fill="white"
      />
    </svg>
  );
};
